import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-109763d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "com-wrap" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "news-title" }
const _hoisted_4 = { class: "dot-wrap" }
const _hoisted_5 = ["onClick"]

import { ref, reactive } from "vue";
import { ElCarouselItem, ElCarousel } from "element-plus";
import "element-plus/theme-chalk/el-carousel.css";
import "element-plus/theme-chalk/el-carousel-item.css";
import "element-plus/theme-chalk/base.css";
import { getArticleCarousel } from "../request/api";
import { useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'swiperNews',
  setup(__props) {

const router = useRouter();
let articleList = ref([]);
let currentDot = ref(0);
let getData = () => {
  getArticleCarousel({}).then(res => {
    articleList.value = res.data.data;
    console.log(articleList.value, "articleList.value2444444");
  });
};
// 获取元素引用
let swiper = ref(null);
let changeCurent = index => {
  console.log(index, 454545);
  swiper.value.setActiveItem(index);
  // swiper.value = index;
  //   console.log(swiper.value.setActiveItem(currentDot.value), 343433);
};
let swiperChange = e => {
  console.log(e, 454545);
  currentDot.value = e;
};
getData();
let articleDetail = item => {
  console.log(item, "item");
  // console.log(id,"id")
  router.push({
    path: "/pages/detail/detail",
    query: {
      id: item.id,
      level1Id: item.column.parent_id,
      level2Id: item.column_id
    }
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(ElCarousel), {
      class: "swiper-wrap",
      height: "300px",
      autoplay: false,
      ref_key: "swiper",
      ref: swiper,
      "indicator-position": "none",
      onChange: _unref(swiperChange),
      arrow: "always"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(articleList), (item) => {
          return (_openBlock(), _createBlock(_unref(ElCarouselItem), {
            class: "swiper-item",
            onClick: ($event: any) => (_unref(articleDetail)(item)),
            key: item.image_url
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                class: "img",
                src: item.image_url,
                alt: ""
              }, null, 8, _hoisted_2),
              _createElementVNode("div", _hoisted_3, _toDisplayString(item.title), 1)
            ]),
            _: 2
          }, 1032, ["onClick"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["onChange"]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(articleList), (dotitem, dotindex) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["dot", dotindex==_unref(currentDot)?'active':'']),
          onClick: ($event: any) => (_unref(changeCurent)(dotindex)),
          key: dotindex
        }, null, 10, _hoisted_5))
      }), 128))
    ])
  ]))
}
}

})